import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  workflowSubdivision,
  data as dataSelector,
  data2 as data2Selector,
} from '../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_EMERGENCY_FUND_GOAL_API } from './EmergencyFundWorkflowConstants';

export const yearsOptionsSelector = createSelector(workflowSubdivision, ({ data }) =>
  get(data, 'YearsOptions', []).map(year => year.toString()));

export const defaultTargetAmountSelector = createSelector(workflowSubdivision, ({ data }) =>
  get(data, 'GoalDefaultTargetAmount'));

export const defaultTargetYearSelector = createSelector(workflowSubdivision, ({ data }) =>
  get(data, 'GoalDefaultTargetYear'));

export const goalSelector = createSelector(dataSelector, data2Selector, (data, data2) => ({
  ...data(BACKEND_EMERGENCY_FUND_GOAL_API),
  ...data2(BACKEND_EMERGENCY_FUND_GOAL_API),
}));

export const emergencyFundTargetAmountOrDefaultSelector = createSelector(
  workflowSubdivision,
  (subdivision = {}) => get(
    subdivision,
    'data.EmergencyFundGoal.FundSize',
    get(subdivision, 'data.GoalDefaultTargetAmount', null),
  ),
);

export const emergencyFundTargetYearOrDefaultSelector = createSelector(
  workflowSubdivision,
  (subdivision = {}) => get(
    subdivision,
    'data.EmergencyFundGoal.FundedDate',
    get(subdivision, 'data.GoalDefaultTargetYear', null),
  ),
);
